



























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import { TransferSchedule } from "@/shared/types";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { usePersonalContributionSchedulesStore } from "@/shared/store/personalContributionSchedules";
import ContributionsActivity from "@/shared/components/contributionsV3/ContributionsActivity.vue";
import TransferSchedulesTable from "@/shared/components/TransferSchedulesTable.vue";

@Component ({
  components: {
    ContributionsActivity,
    TabGroup,
    Tab,
    TransferSchedulesTable
  }
})
export default class ContributionScheduleTabs extends Vue {
  bankAccountStore = useBankAccountStore();
  contributionSchedulesStore = usePersonalContributionSchedulesStore();

  @Prop()
  schedulesPage: number;

  @Prop()
  activityPage: number;

  @Prop()
  tab: string;

  @Prop({required: false})
  routeToModifySchedule: (schedule: TransferSchedule) => Location;

  @Prop({required: false})
  username: string;

  @Prop({required: false})
  partnerId: number;

  @Prop()
  futureContributionsPage: number;

  @Prop()
  readOnly: boolean;

  @Prop()
  cancelOnly: boolean;

  @Prop({default: false})
  displayCancelationDetails: boolean;

  mounted (): void {
    this.bankAccountStore.loadLinkedBankAccounts();

    this.contributionSchedulesStore.getPersonalContributionSchedules(this.args);
    this.contributionSchedulesStore.getFutureContributions(this.args);

    this.$on("tab-clicked", (event, tab) => {
      this.handleTabChange(tab.type);
    });
  }

  get isLoaded (): boolean {
    return this.contributionSchedulesStore.schedulesLoaded && this.bankAccountStore.linkedAccountsLoaded &&
      this.contributionSchedulesStore.isFutureContributionsLoaded;
  }

  get args () {
    return {
      username: this.username,
      partnerId: this.partnerId
    };
  }

  handleTabChange (filter): void {
    this.$router.push({query: {...this.$route.query, tab: filter}});
  }

  @Watch("contributionSchedulesStore.schedulesLoaded")
  reloadSchedules (value) {
    if (!value && !this.contributionSchedulesStore.schedulesLoading) {
      this.contributionSchedulesStore.getPersonalContributionSchedules(this.args);
    }
  }

  @Watch("contributionSchedulesStore.isFutureContributionsLoaded")
  reloadFutureContributions (value) {
    if (!value && !this.contributionSchedulesStore.futureContributionsLoading) {
      this.contributionSchedulesStore.getFutureContributions(this.args);
    }
  }

  @Watch("schedulesPage")
  loadPage () {
    this.contributionSchedulesStore.setSchedulesPage(this.schedulesPage);
  }
}
